/**
 * Created by JackCui on 2021/12/13
 */

import {LAYOUT_TYPE} from '../../../utils/share'

// 表格是否包在group组件内
const groupViewContent = (viewContent) => {
  return [
    {
      targetType: 'group-render',
      props: {
        hideHeader: true
      },
      viewContent
    }
  ]
}

// tab下的列表
export const listSchemaHandle = {
  handle (node, {info, buttonMap, config = {}}) {
    const {layoutType, enableOperationColumn, inlineButtonShowQuantity} = info
    const masterRelation = layoutType === LAYOUT_TYPE.LAYOUT_TYPE_LIST_MASTER_RELATION_MORE
    const buttons = buttonMap['section_batch'] || []
    const {filter, data} = node
    let viewContent = [
      {
        targetType: 'table',
        elementLinks: data.columns,
        inlineButtonShowQuantity,
        enableOperationColumn,
        batchButtons: buttons
      }
    ]

    // todo 修改
    if (config.table?.props?.showListButton !== false) {
      viewContent.unshift({
        targetType: 'buttons',
        buttons,
        maxLength: '5',
        size: 'mini'
      })
    }

    viewContent = masterRelation ? viewContent : groupViewContent(viewContent)

    if (filter) {
      viewContent.unshift({
        ...filter,
        targetType: 'fieldGroup_type_filter'
      })
    }
    return {
      viewComponentName: node.viewComponentName,
      viewContent,
      _type: 'list'
    }
  }
}
